<template>
  <form id="" @submit.prevent="createProjectType">
    <Card :title="$t('projectTypes.creation')" class="card p-5"> 
      <template #cardBody>
        <ProjectTypeForm :type="type"/>
      </template>
      <template #cardFooter>
        <div class="d-flex justify-content-end ">
          <Button type="cancel" btn-class="btn-sm me-2" btn-text="button.cancel"  @click.prevent="router.back" size="7px 30px"></Button>
          <Button type="submit" btn-class="btn-sm me-2" btn-text="button.save" size="7px 30px" :isDisabled="submitting" :isLoading="submitting"></Button>
        </div>
      </template>
    </Card>
  </form>
</template>

<script setup>

import { onMounted, ref} from "vue";
import i18n from '@/plugins/i18n';
import {useStore} from "vuex";
import {useHasAbility} from "@/composables/hasAbility";
import { useLocales } from "@/composables/locales";
import {useSwal} from "@/composables/useSwal";
import ProjectTypeForm from "@/Modules/Projects/components/ProjectType/ProjectTypeForm.vue";
import {useRoute, useRouter} from "vue-router";
import Card from "@/components/Card.vue";
import Button from "@/components/Button.vue";

const route = useRoute()
const router = useRouter()
const store = useStore()
const {locale, datatableLocaleUrl} = useLocales()
const { can } = useHasAbility()
const {showSwal} = useSwal()

const isLoading = ref(false)
const submitting = ref(false)

const type = ref(
  {
    id: null,
    name: "",
    description: "",
    prefix: "",
    configs: [],
    tables: []
  }
)


const createProjectType = () => {
  submitting.value = true
  store.dispatch('projectCategories/storeProjectCategory', type.value)
      .then((response) => {
        window.toastr['success'](i18n.global.t('notification.project_type_created'))
        router.push({ name: 'settings-projects-categories' })
      })
      .catch(err => {
      }).finally(() => submitting.value = false)
}

function loadData() {
  isLoading.value = true
  Promise.all([
    store.dispatch('taskStatus/loadTaskStatus'),
    store.dispatch('milestoneCategories/loadTaskMilestones'),
    store.dispatch('taskPriorities/loadTaskPriorities'),
    store.dispatch("projectCategories/loadCategoryGroups"), 
  ]).finally(() => {
    isLoading.value = false
  })
}


onMounted(() => {
  loadData()
})
</script>
